import { ParametrosWSBase, DestinoConexion } from "../ParametrosWSBase";
import { EncabezadoRespuestaInterna } from "../EncabezadoRespuestaInterna";

export function SSOrdenesCandadoRestService_Parametros(datos: any) {
  var par: ParametrosWSBase = {
    nombreProceso: "SSOrdenesCandadoRest",
    rutaEndPoint: "/SSOrdenesCandadoRest",
    sistemaOrigen: "Web",
    AGREGAR_ENCABEZADO: false,
    DESTINO_SERVICIO: DestinoConexion.BackendSelfService,
    parametros: { ...datos },
        cRC:null
  };

  return par;
}

//ENTRADA
export interface SSOrdenesCandadoRestService_entrada {
  SESION: string | null
  PROCESO: string
  CUENTA_MIGRA: string
  FUENTE: string
  ID_CUENTA: string | null
}


export function builtSSOrdenesCandadoRestServiceEntrada(p_SESION: string | null,p_PROCESO: string,
                                                        p_CUENTA_MIGRA: string,p_FUENTE: string,
                                                        p_ID_CUENTA: string | null) {
    var retorno: SSOrdenesCandadoRestService_entrada ={
      SESION: p_SESION,
      PROCESO: p_PROCESO,
      CUENTA_MIGRA: p_CUENTA_MIGRA,
      FUENTE: p_FUENTE,
      ID_CUENTA: p_ID_CUENTA
  };
  return retorno;
}



//SALIDA
export interface SSOrdenesCandadoRestService_salida {
    codigoError: CodigoError
    resultado: Resultado
}
  
export interface CodigoError {
    codigo: string
    mensaje: string
}
  
export interface Resultado {
    RESUL: string
    COMENT: string
    CVAL1: string
    CVAL2: string
}
  
  


export type SSOrdenesCandadoRestService_Respuesta = SSOrdenesCandadoRestService_salida;